module.exports = __webpack_public_path__ + "static/wtt-19d1f5b65611a2236cbefc2b621b66f7.png";